import { DataGridLayout, List, ListHeader, ListPageLayout, SearchInput } from 'framework/list';
import { CreateButton } from 'framework/ui/ui-builder';
import { BooleanField, FullDateField, SearchLinkField, TextField } from 'framework/ui/field';
import { UPDATE_SERVICE, useServiceService } from 'domain/shared/service';
import { useServiceUrl } from 'domain/shared/service';
import EditServiceButton from 'domain/organization/service/List/button/EditServiceButton';
import { EmployeeLinkField } from 'domain/shared/employee';
import { BudgetLinkField } from 'domain/shared/budget';
import { useWasteUrl, CREATE_WASTE } from 'domain/shared/waste';

const ServiceList = () => {
  const { search } = useServiceService();
  const { getSingleEntityUrl } = useServiceUrl();
  const { getCreateUrl: getWasteCreateUrl } = useWasteUrl();

  return (
    <List getDataMethod={search} defaultSortOrder="DESC" defaultSortField="updatedAt">
      <ListPageLayout
        data-hj-suppress
        header={<ListHeader label="Services" icon="fa-folder-o" />}
        actions={[
          <CreateButton
            url={getWasteCreateUrl()}
            label="Report Waste"
            key="create-waste"
            permissionToCheck={CREATE_WASTE}
          />,
        ]}
        search={<SearchInput label="service name" />}
      >
        <DataGridLayout
          buttons={[
            <EditServiceButton
              key="edit-service"
              source="id"
              outline
              permissionToCheck={UPDATE_SERVICE}
              isVisible={false}
            />,
          ]}
        >
          <SearchLinkField source="id" label="Service ID" url={getSingleEntityUrl} isSortable width={140} />
          <TextField source="name" label="Service Name" isSortable />
          <BudgetLinkField
            label="Default Budget"
            source="defaultBudgetId"
            nameSource="defaultBudget.name"
            width={140}
          />
          <EmployeeLinkField
            source="ownerId"
            sortSource="ownerNameEn"
            nameSource="ownerName"
            label="Owner"
            width={150}
            isSortable
          />
          <FullDateField source="updatedAt" label="Last Modified Date" isSortable />
          <BooleanField source="assignmentForbidden" label="Assignment Forbidden" isSortable />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default ServiceList;
